import { Category2, Home2, KeySquare, Share, User } from "iconsax-reactjs";
import type React from "react";

export type NavLabelKey = "home" | "dashboard" | "investment" | "dao" | "more";
export interface NavDestination {
  href: string;
  icon: React.ComponentType<{
    variant: "Bold" | "Linear";
    size?: number | string;
    className?: string;
  }>;
  labelKey: NavLabelKey;
}
export const NAV_DESTINATIONS: NavDestination[] = [
  { href: "/", icon: Home2, labelKey: "home" },
  { href: "/profile/dashboard", icon: User, labelKey: "dashboard" },
  { href: "/info/investment", icon: KeySquare, labelKey: "investment" },
  { href: "/info/dao", icon: Share, labelKey: "dao" },
  { href: "/info", icon: Category2, labelKey: "more" },
];
const matches = (path: string, prefix: string) =>
  path === prefix || path.startsWith(`${prefix}/`);
export function isNavDestinationActive(
  currentPath: string | null | undefined,
  href: string,
): boolean {
  if (!currentPath) return false;
  const path = currentPath.replace(/\/$/, "") || "/";
  const target = href.replace(/\/$/, "") || "/";
  if (target === "/") return path === "/";
  if (target === "/profile/dashboard")
    return (
      matches(path, target) || matches(path, "/profile/standard-dashboard")
    );
  if (target === "/info")
    return [
      "/info",
      "/info/swap",
      "/info/smart-contracts",
      "/info/statement",
      "/info/guide",
      "/blog",
    ].some((prefix) =>
      prefix === "/info" ? path === prefix : matches(path, prefix),
    );
  return matches(path, target);
}
